import { api } from '../../api';

export const claimPrem365 = async () => {
  const url = 'v1/wallet/prem/365/claim';
  try {
    return await api.put(url);
  } catch (err) {
    return console.error('Claim prem 365 err', err);
  }
};
